import Movement from "./movement";

export default class Press extends Movement {
  render = () => {
    this.setupContext();

    this.context.setLineDash([6, 6]);
    this.context.strokeStyle = "rgba(0, 0, 0, 1)";
    this.context.fillStyle = "rgba(0, 0, 0, 1)";

    this.renderMovement();
    this.renderArrow();
    this.resetContext();
  }

  renderArrow = () => {
    if (this.points.length === 0) {
      return
    }

    const lastPoint = this.points[this.points.length - 1];
    const headLen = 15 * this.context.scale;
    const angle = Math.atan2(lastPoint[3] - lastPoint[1], lastPoint[2] - lastPoint[0]);
    const toX = lastPoint[2] * this.context.scale;
    const toY = lastPoint[3] * this.context.scale;

    this.context.beginPath();
    this.context.moveTo(toX - headLen * Math.cos(angle - Math.PI / 2), toY - headLen * Math.sin(angle - Math.PI / 2));
    this.context.lineTo(toX + headLen * Math.cos(angle - Math.PI / 2), toY + headLen * Math.sin(angle - Math.PI / 2));
    this.context.setLineDash([]);
    this.context.stroke();
  }

}
